<!--题库-->
<template>
  <div class="content">
    <div class="content-left">
      <div class="content-left-header">
        <div class="content-left-header-item">
          <label class="content-left-header-item-note">选择题型</label>
          <el-select v-model="type" placeholder="" class="content-left-header-item-input" >
            <el-option
              v-for="item in typeListCopy"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              size="medium"
            />
          </el-select>
        </div>
        <div class="content-left-header-item">
          <label class="content-left-header-item-note">搜索题目</label>
          <el-input
            v-model="searchKey"
            placeholder=""
            class="content-left-header-item-input"
            size="medium"
            clearable
          >
          <template #suffix>
            <i class="iconfont icon-sousuo content-left-header-item-input-search" />
          </template>
        </el-input>
        </div>
      </div>
      <div class="content-left-list">
        <div class="content-left-list-head">
          <label class="content-left-list-head-note">{{title}}</label>

          <button class="content-left-list-head-btn" @click="addClick">
            <img src="../../assets/add.png" class="content-left-list-head-btn-icon">
            添加试题
          </button>
        </div>
        <div class="content-left-list-all">
          <div class="content-left-list-all-item" v-for="(item, index) in dataListFilter" :key="index">
            <div class="content-left-list-all-item-order" @click="editClick(item, index)">{{index+1}}/{{dataList.length}}</div>
            <div class="content-left-list-all-item-type" @click="editClick(item, index)">{{typeList.find(x=>x.code==item.type).name}}</div>
            <div class="content-left-list-all-item-title" @click="editClick(item, index)">{{item.questionsList}}</div>
            <!-- <img class="content-left-list-all-item-icon" src="../../assets/edit.png" @click="editClick(item, index)"/> -->
            <span class="content-left-list-all-item-curr-node-opt">
              <i title="删除" class="el-icon-delete" @click="delClick(item, index)"></i>
              <i title="编辑" class="el-icon-edit" @click="editClick(item, index)"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="content-right" v-if="isAdd">
      <div class="content-right-head">
        <label class="content-right-head-note">选择题型：</label>
        <el-select v-model="questionBankList.type" placeholder="" class="content-right-header-input">
          <el-option
            v-for="item in typeList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
            size="medium"
          />
        </el-select>
        <!-- <button class="content-right-head-btn" @click="addClick">
          <img src="../../assets/add.png" class="content-right-head-btn-icon">
          添加试题
        </button> -->
      </div>
      <div class="content-right-question">

        <label class="content-right-question-note">编辑题干：</label>
        <el-input
        class="content-right-question-input"
          v-model="questionBankList.questionsList"
          :rows="3"
          type="textarea"
          placeholder="请输入题干"
          clearable
        />
      </div>
      <div class="content-right-items" >
        <label class="content-right-items-note">编辑选项：</label>
        <div class="content-right-items-list">
          <div class="content-right-items-list-head">
            <label class="content-right-items-list-head-answer">正确答案</label>
            <label class="content-right-items-list-head-text">选项内容</label>
            <label class="content-right-items-list-head-operate">操作</label>
          </div>
          <el-radio-group
            v-if="questionBankList.type===0"
            v-model="radio"
            @change="radiochanged"
          >
            <div class="content-right-items-list-item" v-for="(item, index) in questionBankList.questionBankListOptionses" :key="item">
              <div class="content-right-items-list-item-answer" >
                <el-radio
                  class="content-right-items-list-item-answer-radio"
                  v-model="item.isTure"
                  size="large"
                  :label="index"
                >
                </el-radio>
              </div>
              <el-input
                v-model="item.optionsList"
                size="medium"
                placeholder="请输入选项内容"
                class="content-right-items-list-item-input"
                clearable
              ></el-input>
              <div class="content-right-items-list-item-operate">
                <div class="content-right-items-list-item-operate-btn" @click="itemOperate('add', index)">添加</div>
                <div class="content-right-items-list-item-operate-btn" @click="itemOperate('delete', index)">删除</div>
                <div class="content-right-items-list-item-operate-btn" @click="itemOperate('up', index)">上移</div>
                <div class="content-right-items-list-item-operate-btn" @click="itemOperate('down', index)">下移</div>
              </div>
            </div>
          </el-radio-group>
          <div v-else>
            <div class="content-right-items-list-item" v-for="(item, index) in questionBankList.questionBankListOptionses" :key="item">
              <div class="content-right-items-list-item-answer" >
                <el-radio
                class="content-right-items-list-item-answer-radio"
                v-model="item.isTure"
                size="large"
                :label="index"
                v-if="questionBankList.type===0"
                >
                </el-radio>

                <el-checkbox
                class="content-right-items-list-item-answer-radio"
                v-model="item.isTure"
                size="large"
                v-if="questionBankList.type===1"
                />
                <el-select class="content-right-items-select" v-model="item.marryType" placeholder="匹配类型" v-if="questionBankList.type===2">
                  <el-option label="精准匹配" :value="0"></el-option>
                  <el-option label="模糊匹配" :value="1"></el-option>
                </el-select>
              </div>
              <el-input v-model="item.keyword" placeholder="关键词" v-if="questionBankList.type===2"></el-input>
              <el-input
                v-if="questionBankList.type===0||questionBankList.type===1"
                v-model="item.optionsList"
                size="medium"
                placeholder="请输入选项内容"
                class="content-right-items-list-item-input"
                clearable
              ></el-input>
              <div class="content-right-items-list-item-operate">
                <div class="content-right-items-list-item-operate-btn" @click="itemOperate('add', index)">添加</div>
                <div class="content-right-items-list-item-operate-btn" @click="itemOperate('delete', index)">删除</div>
                <div class="content-right-items-list-item-operate-btn" @click="itemOperate('up', index)">上移</div>
                <div class="content-right-items-list-item-operate-btn" @click="itemOperate('down', index)">下移</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right-anlysis">
        <label class="content-right-anlysis-note">题目解析：</label>
        <el-input
        class="content-right-anlysis-input"
          v-model="questionBankList.analysis"
          :rows="3"
          type="textarea"
          placeholder="请输入解析"
          clearable
        />
      </div>
      <div class="content-right-anlysis">
        <label class="content-right-anlysis-note">图片解析：</label>
        <img
          :src="headIMG(questionBankList.questionBankListAnalysisImgs)"
          @click="imageClick('1',questionBankList.questionBankListAnalysisImgs)"
          title="点我选择图片解析"
          style="width: 120px;height:120px;cursor:pointer" >
      </div>
      <div class="spring">
      </div>
      <div class="content-right-footer">
        <!-- <button class="content-right-footer-btn content-right-footer-sure" @click="sureAdd">同步</button>-->
        <button class="content-right-footer-btn" @click="cancelAdd">返回</button>
        <button class="content-right-footer-btn content-right-footer-sure" @click="Save" v-if="isShowSave">保存</button>
        <button class="content-right-footer-btn " loading v-if="!isShowSave">Loading...</button>
      </div>
    </div>

  </div>
  <SubResourceCenter
  ref="SubResourceCenter"
  v-model:ResourceCenterDialogVisible="ResourceCenterDialogVisible"
  @close-dialog="ResourceCenterCloseDialog"
  @handle-cancel="ResourceCenterHandleCancel"
  @handle-confirm="ResourceCenterHandleConfirm"
></SubResourceCenter>
</template>

<script>
import {GetQuestionBankListById , EditQuestionBankList, deleteQuestionTopic} from "@api/Exam/ApiQuestionBankList";
import { useRouter } from "vue-router";
import { ossPreview } from "@/util/ossClient.js"
import SubResourceCenter from "@views/YZResource/SubResourceCenter.vue";
import { ElMessageBox } from 'element-plus'
export default {
  name: "QuestionBankEdit",
  data() {
    return {
      ResourceCenterDialogVisible:false,
      main:{},
      mainId:0,
      router:useRouter(),
      type: -1,
      isShowSave:true,
      typeList:[{name:"单选",code:0},{name:"多选",code:1},{name:"问答",code:2}],
      typeListCopy:[{name:"-全部-",code:-1},{name:"单选",code:0},{name:"多选",code:1},{name:"问答",code:2}],
      searchKey: "",
      dataList: [],
      title:'',
      isAdd:true,
      addQuestion:"",
      addAnswer: "",//单选答案
      addAalysis: "",
      operateData: {
        type: 0, //0：添加， 1：编辑 默认添加
        index: 0
      },
      operation:'',
      //题库题目项
      questionBankList:{
        markid:this.getGuid(),
        questionBankId:this.mainId,
        type:0,
        questionsList:'',
        analysis:'',
        questionBankListAnalysisImgs:[],//图片解析
        questionBankListOptionses:[
          {
            questionBankListId:0,
            number:1,
            isTure:false,
            optionsList:'',
            keyword:'',
            marryType:1
          }
        ]//题库选项表
      },
    };
  },
  components: {
    SubResourceCenter,
  },
  computed:{
    dataListFilter(){
      return this.dataList.filter(item=>{
        if(this.searchKey!="")return item.questionsList.indexOf(this.searchKey)!=-1
        else{
          if(this.type!= -1)return item.type == this.type
          else return true
        }
      })
    },
    radio(){
      if (this.questionBankList.type == 0 &&
          this.questionBankList.questionBankListOptionses.length > 0) {
        let defaultoption = this.questionBankList.questionBankListOptionses.find((option) => {
          return option.isTure == true;
        });
        if (defaultoption) {
          let index = this.questionBankList.questionBankListOptionses.indexOf(defaultoption);
          return index;
        }
      }
      return "";
    },
  },
  methods: {
    //图片路径设定
    headIMG(imgs) {

      const imgData = require('../../assets/images/upload.png')
      if(imgs && imgs[0]) {
        if(imgs[0].imgUrl.indexOf("https://")>-1)return imgs[0].imgUrl
        return ossPreview(imgs[0].imgUrl, "1")
      } else {
        return imgData;
      }
    },
    //打开资源弹框入口
    imageClick:function(type,row){
      if(this.IsReadonly)return
      // { GroupTypeCode: "1", GroupTypeName: "图片" },
      // { GroupTypeCode: "2", GroupTypeName: "视频" },
      // { GroupTypeCode: "3", GroupTypeName: "文档" },
      if(!row)row=[]
      this.ResourceCenterDialogVisible=true
      var obj={
        type:[type],//展示的页签
        selectFileType:"1",//选中的文件的类型 1图片，2视频，3文档
        selectId:0,//选中的文件的id
        isSingle:true,//是否单选
        source:"CourseEdit",//数据来源页面
        row:row,//行
        sourceItem:{},//资源文件对象
      };
      if(type == '1'){
        obj.selectFileType = "1"
        obj.selectId = row.length==0?0:row[0].imageId
        obj.type=['1']
      }
      else if(type == '2')
      {
        obj.selectFileType = "2";//row.fileType == undefined ? '2' : row.fileType
        obj.selectId=row[0].resourcesId
        obj.type=['2','3']
      }
      this.$refs.SubResourceCenter.loading(obj);
    },
    ResourceCenterCloseDialog() {
      this.ResourceCenterDialogVisible = false;
    },
    ResourceCenterHandleCancel() {
      this.ResourceCenterDialogVisible = false;
    },
    //选择资源文件之后 点击确认的回调事件
    ResourceCenterHandleConfirm(obj) {
      this.ResourceCenterDialogVisible=false
      if(obj.selectFileType == 1){
        // obj.row.imageId = obj.sourceItem[0].PicLogicalCode
        // obj.row.imgName = obj.sourceItem[0].FileName
        // obj.row.imgUrl = obj.sourceItem[0].ImgSrc
        if(!this.questionBankList.questionBankListAnalysisImgs)this.questionBankList.questionBankListAnalysisImgs=[]
        this.questionBankList.questionBankListAnalysisImgs[0] = {}
        this.questionBankList.questionBankListAnalysisImgs[0].imageId = obj.sourceItem[0].PicLogicalCode
        this.questionBankList.questionBankListAnalysisImgs[0].imgName = obj.sourceItem[0].FileName
        this.questionBankList.questionBankListAnalysisImgs[0].imgUrl = obj.sourceItem[0].ImgSrc
      }
    },
    reset(){
      this.questionBankList={
        markid:-1,
        questionBankId:this.mainId,
        type:0,
        questionsList:'',
        analysis:'',
        questionBankListOptionses:[
          {
            questionBankListId:0,
            number:1,
            isTure:false,
            optionsList:'',
            keyword:'',
            marryType:1
          }
        ]//题库选项表
      }
    },
    addClick(){
      this.reset()
      this.questionBankList.markid = this.getGuid()
    },
    editClick(data, index){
      console.log("editClick="+index, data);

      this.questionBankList = data
      if(!this.questionBankList.questionBankListAnalysisImgs)this.questionBankList.questionBankListAnalysisImgs=[]

    },
    delClick(data, index){
      let _this = this;
      ElMessageBox.confirm('您确认删除该题目吗？删除后数据将不可恢复？', '提示', {
        cancelButtonClass: 'cancelstyle',
        confirmButtonClass: 'confirmstyle',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
      })
        .then(() => {
          this.dataList.splice(index,1);
          deleteQuestionTopic(data.id);
          if(this.questionBankList.id == data.id) {
            _this.reset()
            _this.questionBankList.markid = this.getGuid()
          }
        })
        .catch(() => {
          return
        })
    },
    cancelAdd(){

      this.router.replace({
        name: "题库管理",
        params: {
          from: "QuestionBankEdit",
          isReplace: true,
        },
      });

    },
    getGuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
          return v.toString(16);
      })
    },
    sureAdd(){

      let _this = this
      //验证
      if(!_this.sureAddCheck())return

      var _questionBankList = JSON.parse(JSON.stringify(_this.questionBankList))
      if(_questionBankList.id && this.questionBankList.id!=0){
        //数据库有的
       var obj =  _this.dataList.find(x=>x.id==_questionBankList.id)
       obj = _questionBankList
      }else{
        //dataList 集合中有的
        var obj = _this.dataList.find(x=>x.markid==_questionBankList.markid)
        if(obj){
          obj = _questionBankList
        }else{
          _this.dataList.push(_questionBankList)
        }
      }

      _this.reset()
      _this.questionBankList.markid = this.getGuid()

    },
    sureAddCheck(){
      var err=""
      if(this.questionBankList.questionsList=="")err+=" 题干内容不能为空  "
      // if(this.questionBankList.analysis=="")err+=" 解析不能为空  "
      if(this.questionBankList.type==0||this.questionBankList.type==1){
        if(this.questionBankList.questionBankListOptionses.length==0)err+=" 选项不能为空  "
        else{
          if(this.questionBankList.questionBankListOptionses.find(x=>x.optionsList==''))err+=" 选项内容不能为空  "
          if(!this.questionBankList.questionBankListOptionses.find(x=>x.isTure))err+=" 请设置一个正确选项  "
        }
      }
      else if(this.questionBankList.type==2){
        if(this.questionBankList.questionBankListOptionses.length==0)err+=" 选项不能为空  "
        else{
          if(this.questionBankList.questionBankListOptionses.find(x=>x.keyword==''))err+=" 匹配关键词不能为空  "
        }
      }
      if(err!=''){
        this.$message.error(err)
        return false
      }
      return true
    },
    Save(){

      var _this = this

      //验证
      if(!_this.sureAddCheck())return

      var _questionBankList = JSON.parse(JSON.stringify(_this.questionBankList))
      if(_questionBankList.id && this.questionBankList.id!=0){
        //数据库有的
       var obj =  _this.dataList.find(x=>x.id==_questionBankList.id)
       obj = _questionBankList
      }else{
        //dataList 集合中有的
        var obj = _this.dataList.find(x=>x.markid==_questionBankList.markid)
        if(obj){
          obj = _questionBankList
        }else{
          _this.dataList.push(_questionBankList)
        }
      }

      //保存至数据库
      if(!_this.dataList||_this.dataList.length==0)
      {
        this.$message.error("没有题目数据!");
        return
      }
      const loading = this.loading()
      _this.isShowSave = false
      EditQuestionBankList(_this.main.id,_this.dataList).then(res=>{
        loading.close();
        this.$message.success("操作成功!")
        _this.isShowSave = true

        _this.reset()
        _this.questionBankList.markid = this.getGuid()

      }).catch(res=>{
        loading.close();
        console.log(res)
        _this.isShowSave = true
        this.$message.error(res.message)
      })
    },
    itemOperate(type, index){
      let ans;
      switch(type){
        case "add":
          var option = {}
          option.isTure=false
          option.optionsList=''
          option.keyword=''
          option.marryType=1
          this.questionBankList.questionBankListOptionses.push(option)
          break;
        case "delete":
          this.questionBankList.questionBankListOptionses.splice(index,1)
          break;
        case "up":
          ans = this.questionBankList.questionBankListOptionses[index];
          (index > 0) && this.questionBankList.questionBankListOptionses.splice(index,1) && this.questionBankList.questionBankListOptionses.splice(index-1,0, ans);
          break;
        case "down":
           ans = this.questionBankList.questionBankListOptionses[index];
          (index < this.questionBankList.questionBankListOptionses.length-1) && this.questionBankList.questionBankListOptionses.splice(index,1) && this.questionBankList.questionBankListOptionses.splice(index+1,0, ans);
          break;
        default:
          break;
      }
      // 重新排序
      for(let i=1;i<=this.questionBankList.questionBankListOptionses.length;i++) {
        this.questionBankList.questionBankListOptionses[i-1].number = i;
      }
      console.log('this.questionBankList.questionBankListOptionses',this.questionBankList.questionBankListOptionses);
    },
    setAdd(initData){
      if(initData){
        this.type = initData.code;
        this.addQuestion = initData.title;
        this.addAnswer = initData.answer;
        if(initData.answerList&&initData.answerList.length > 0){
          this.addAnswerList.splice(0, this.addAnswerList.length, ...initData.answerList);
        }else{
          this.addAnswerList.splice(0, this.addAnswerList.length, {text:"", checked:false});
        }

        this.addAalysis = initData.addAnswer||"";
      }else{
        this.type = "";
        this.addQuestion = "";
        this.addAnswer = "";
        this.addAnswerList.splice(0,this.addAnswerList.length, {text:"", checked:false});
        this.addAalysis = "";
      }
    },
    initData(){
      let _this = this
      const loading = this.loading()
      GetQuestionBankListById(this.main.id)
      .then(res=>{
        loading.close();
        if(res)_this.dataList = res
      }).catch(res=>{
        loading.close();
        console.log(res)
      })
    },
     //单选变化事件
    radiochanged (e) {
      if (this.questionBankList.type == 0 &&
          this.questionBankList.questionBankListOptionses.length > 0) {
        let option = this.questionBankList.questionBankListOptionses[e];
        option.isTure = !option.isTure;
        if (option.isTure) {
          //更新其他选项为不选中
          for (let i = 0; i < this.questionBankList.questionBankListOptionses.length; i++) {
            if (i != e) {
              this.questionBankList.questionBankListOptionses[i].isTure = false;
            }
          }
        }
      }
    },
  },
  mounted() {
    var senddata = localStorage.getItem('QuestionBank_senddata')
    //跳转过来携带的参数
    let { operation, main } = JSON.parse(senddata);
    this.operation = operation;
    this.main = main;
    this.title = this.main.name
    this.mainId = this.main.id
    this.initData();

  },
};
</script>
<style lang="less" scoped>
.content{
  display: flex;
  flex-direction: row;
  background: #F0F2F5;
  box-sizing: border-box;
  padding: 0;
  margin: 0;


  &-left{
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-right: 8px;
    &-header{
      display: flex;
      padding: 15px;
      background-color: #fff;
      margin-bottom: 8px;

      &-item{
        display: flex;
        flex-direction: column;
        width: 210px;
        margin-right: 20px;

        &-note{
          font-size: 16px;
          font-weight: 400;
          color: #24335A;
          line-height: 24px;
        }
        &-input{
          width: 100%;

          &-search{
            font-size: 15px;
            color: #C1CACF;
            padding: 5px;
          }
        }
      }
    }

    &-list{
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      overflow: hidden;
      padding: 15px;
      background-color: #fff;

      &-head{
        display: flex;
        // flex-direction: column;
        padding: 15px 0;
        justify-content: space-between;

        &-note{
          font-size: 20px;
          font-weight: 500;
          color: #262A33;
          line-height: 24px;
          // padding: 20px 0;
        }
        &-btn{
          width: 100px;
          height: 32px;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          background: #0747A6;
          border-radius: 2px 2px 2px 2px;
          display: flex;
          justify-content: center;
          align-items: center;


          &-icon{
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
        }
      }
      &-all{
        felx: 1;
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow: scroll;
        overflow-x: hidden;

        &-item{
          display: flex;
          align-items: center;
          width: 100%;
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #C9D1D6;
          padding: 8px;
          box-sizing: border-box;
          margin: 5px 0;
          cursor: pointer;

          &-order{
            padding: 2px 8px;
            background: #0747A6;
            border-radius: 2px 2px 2px 2px;
            font-size: 10px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            margin-right: 5px;
          }
          &-type{
            font-size: 10px;
            font-weight: 400;
            color: #0747A6;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #0747A6;
            padding: 2px 8px;
            margin-right: 5px;
          }
          &-title{
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            flex: 1;
          }
          &-icon{
            width: 15px;
            height: 15px;
            cursor: pointer;
          }
          &-curr-node-opt i {
            margin-left: 5px;
          }
        }
      }
    }
  }
  &-right{
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 15px;
    background-color: #fff;
    overflow: scroll;
    overflow-x: hidden;

    &-head{
      display: flex;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px solid #D8DEE8;

      &-note{
        font-size: 16px;
        font-weight: 400;
        color: #24335A;
        min-width: 85px;
      }
      &-input{
        width: 125px;
      }
    }
    &-question{
      display: flex;
      padding-top: 20px;

      &-note{
        font-size: 16px;
        font-weight: 400;
        color: #24335A;
        min-width: 85px;
      }
      &-input{
        font-size: 16px;
        font-weight: 400;
        color: #000000;
      }
    }
    &-items{
      display: flex;
      padding-top: 20px;

      &-note{
        font-size: 16px;
        font-weight: 400;
        color: #24335A;
        min-width: 85px;
      }
      &-list{
        display: flex;
        flex-direction: column;
        width: 100%;
        border: 1px solid #C9D1D6;
        border-radius: 2px;

        &-head{
          display: flex;
          padding: 10px 0;
          background: #E6F7FF;

          &-answer{
            min-width: 80px;
            text-align: center;
            font-size: 12px;
            font-weight: 500;
            color: #0747A6;
          }
          &-text{
            flex: 1;
            font-size: 12px;
            font-weight: 500;
            color: #0747A6;
            text-align: center;
          }
          &-operate{
            width: 150px;
            text-align: center;
            font-size: 12px;
            font-weight: 500;
            color: #0747A6;
          }
        }
        &-item{
          padding: 5px 0;
          display: flex;
          align-items: center;
          &-answer{
            min-width: 80px;
            text-align: center;
          }
          &-input{
            flex: 1;
          }
          &-operate{
            display: flex;
            justify-content: space-around;
            align-items: center;
            min-width: 150px;

            &-btn{
              font-size: 12px;
              font-weight: 400;
              color: #0747A6;
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
      }
      &-select :deep(.el-input--suffix .el-input__inner) {
        padding-left: 5px;
        padding-right: 15px;
      }
    }
    &-anlysis{
      display: flex;
      padding-top: 20px;

      &-note{
        font-size: 16px;
        font-weight: 400;
        color: #24335A;
        min-width: 85px;
      }
      &-input{
        font-size: 16px;
        font-weight: 400;
        color: #000000;
      }
    }
    &-footer{
      display: flex;
      justify-content: flex-end;

      &-btn{
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #707070;
        font-size: 14px;
        font-weight: 400;
        padding: 10px 25px;
        margin: 10px;
      }

      &-sure{
        background: #0747A6;
        color: #FFFFFF;
        border: 1px solid #0747A6;
      }
    }
  }
  :deep(.el-radio__label){
    display: none;
  }
  :deep(.el-radio__input.is-checked .el-radio__inner){
    border-color: #0747A6;
    background: #0747A6;
  }
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner){
    border-color: #0747A6;
    background: #0747A6;
  }
  .spring{
    flex: 1;
    &-btn {
      margin-left: 0px;
    }
  }
}
</style>